module.exports = __webpack_public_path__ + "static/media/composition.c61ed752.rdpcomposer";